import { Text } from '@user-portal/wikr-components';

import * as S from './styled';

import { FitnessLevelCardProps } from './types';

const FitnessLevelCard = ({ title, description, isActive, Icon, onClick, id }: FitnessLevelCardProps) => (
    <S.CardWrapper isActive={isActive} onClick={() => onClick(id)} data-locator="fitnessLevelCard">
        <div>
            <Text mb={4} bold>
                {title}
            </Text>
            <S.Description type="small-text" color="text-secondary">
                {description}
            </S.Description>
        </div>
        <Icon />
    </S.CardWrapper>
);

export default FitnessLevelCard;
